export default {
  'login.succeed': 'Berhasil masuk',
};
